import EmailIcon from '@mui/icons-material/Email';
import { Box, Button, CircularProgress, Stack, Tooltip, Typography } from '@mui/material';
import { useStoreState } from 'pullstate';
import React, { useEffect, useState } from 'react';
import { AppStore } from '../../stores/AppStore.js';
import { readyForApproval } from '../../utils/apiFunctions';

const NotifyCoachReadyForApproval = ({ peopleBuilder }) => {
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
    const [loading, setLoading] = useState(false)
    const [coachNotified, setCoachNotified] = useState('')
    const user = useStoreState(AppStore, s => s.user)

    const handleClick = async () => {
        setLoading(true)
        const messageResponse = await readyForApproval(peopleBuilder, user)
        const date = new Date();
        const formattedDate = date.toLocaleDateString('en-ca', { year: 'numeric', month: '2-digit', day: '2-digit' });
        const formattedTime = date.toLocaleTimeString('en-ca', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        const currentDate = `${formattedDate} at ${formattedTime}`;

        if (messageResponse.status === 200) {
            setCoachNotified(currentDate)
            localStorage.setItem('coachNotified', currentDate)
            openAlert('Coach has been notified', 'success')
        } else {
            openAlert('Oops! Something went wrong', 'error')
        }
        setLoading(false)
    }

    useEffect(() => {
        setCoachNotified(localStorage.getItem('coachNotified'))
    }, [coachNotified])

    return (
        <Box sx={{ position: 'relative' }}>
            <Stack direction='row' sx={{ justifyContent: 'right' }}>
                <Stack alignItems='center'>
                    <Tooltip title='Send notification to coach about goals ready for approval' placement='top'>
                        <Button onClick={handleClick} disabled={loading} sx={{ fontSize: 10 }} >
                            <EmailIcon sx={{ fontSize: 18, marginRight: 1 }} />
                            Notify coach
                        </Button>
                    </Tooltip>
                    <Typography sx={{ fontSize: '10px', color: 'darkgray' }} variant="subtitle2" color="initial">{coachNotified ? `Notified on ${coachNotified}` : ''}</Typography>
                </Stack>
            </Stack >
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px'
                    }}
                />
            )}
        </Box>
    )
}

export default NotifyCoachReadyForApproval